import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPostAuthorizedServicesProcedur } from '../models/models'
import { CommonPostResponse } from '../../../components/models/models'

export class PostAuthorizedServicesProcedurApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesProcedur/insert',
      requesterInfo,
    })
  }

  public async postAuthorizedServicesProcedur(request: IPostAuthorizedServicesProcedur): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
